import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import CompatibleWithHelper from '../utils/CompatibleWithHelper';
import { forOwn as _forOwn } from 'lodash-es';
import _ from 'lodash-es';
import ProductAddToCart from '../utils/ProductAddToCart';
import ProductExtraData from '../utils/ProductExtraData';
import { ProductPriceString } from '../utils/ProductPriceString';

import { FormattedNumber } from 'react-intl';
import { defaultCurrency, defaultCurrencySub } from '../utils/Constants';
import '../../styles/product.scss';

class Product extends React.Component {
  constructor(props) {
    super();
    const variants = [];
    let optionsArray = [];
    if (props.data.variants.length > 1) {
      const group = _.groupBy(props.data.variants, 'merchantProductId');
      _forOwn(group, (collapsedVariants, key) => {
        variants.push(collapsedVariants[0]);
      });

      variants.forEach(variant => {
        optionsArray.push({
          id: variant.merchantProductSku,
          value: variant.variantTitle,
        });
      });
    }

    this.state = {
      data: props.data,
      variants: variants,
      variantOptions: optionsArray,
      onClick: props.onClick,
      productName: props.productName,
      showAddtoCart: props.showAddtoCart,
      productLink: '',
      IsOnSale: false,
      currentProduct: props.data.variants[0],
    };
  }

  /*note - these methods are for fetching the options seperately instead of single dropdown
   keeping these just in case they are requied later.
  */

  // getDefaultSelection = options => {
  //   const currentProduct = this.state.currentProduct;
  //   let selection = currentProduct.options.find(
  //     option => option.name === options.name
  //   ).value;
  //   return selection;
  // };

  // getVariantId = optionString => {
  //   const currentOptions = this.state.currentOptions;
  //   let id = currentOptions.find(current => current.value === optionString);
  //   return id;
  // };

  selectComponent = () => {
    const variantOptions = this.state.variantOptions;
    const selected = this.state.currentProduct.merchantProductSku;
    variantOptions.sort(function(a, b) {
      return +a.id - +b.id;
    });
    // console.log(variantOptions, 'variantOptions');
    return (
      <select
        value={selected}
        onChange={this.handleSelectVariantChange}
        className="xrsselect"
      >
        {variantOptions.map(variantOption => (
          <option
            id={variantOption.id}
            value={variantOption.id}
            key={variantOption.id}
            className="xrs-product__option-text"
          >
            {variantOption.value}
          </option>
        ))}
      </select>
    );
  };

  handleSelectVariantChange = event => {
    const variants = this.state.variants;
    const id = event.target.value;
    const newVariant = variants.find(
      variant => variant.merchantProductSku === id
    );
    this.setState({
      currentProduct: newVariant,
    });
  };

  render() {
    const productVariantsDetails = this.state.data;
    const singleProduct = this.state.currentProduct;
    const optionsize = productVariantsDetails.variants.length;
    const IsOnSale =
      singleProduct.price < singleProduct.compareAtPrice &&
      singleProduct.compareAtPrice != 0
        ? true
        : false;
    let isSimpleProduct =
      productVariantsDetails.variants.length <= 1 ? true : false;

    let productLink =
      `${singleProduct.url_product}#${CompatibleWithHelper.keyMap.compatibleWith}=` +
      encodeURIComponent(this.props.productName) +
      `&${CompatibleWithHelper.keyMap.sourceMerchantProductVariantID}=` +
      encodeURIComponent(this.props.sourceMerchantProductSku) +
      `&${CompatibleWithHelper.keyMap.sourceCompatioCategoryId}=${this.props.sourceCompatioCategoryId}` +
      `&${CompatibleWithHelper.keyMap.productPosition}=${this.props.productPosition}` +
      `&${CompatibleWithHelper.keyMap.categoryPosition}=${this.props.categoryPosition}`;
    // console.log(this.props, 'this.props');
    return (
      <div className="xrs-product">
        <div className="xrs-product__content-container">
          <a
            onClick={() => this.props.onClick(singleProduct)}
            href={productLink}
            className="xrs-product__link"
          >
            <div className="xrs-product__image-wrapper">
              <div className="info">
                {IsOnSale ? <label className="sale">Sale</label> : null}
              </div>
              <div className="xrs-product__image-ratio">
                <div className="xrs-product__image-container">
                  <img
                    src={singleProduct.url_image}
                    // Ensure HTML encoded entities display properly
                    alt={ReactHtmlParser(singleProduct.variantName)}
                    className="xrs-product__image"
                  />
                </div>
                {optionsize > 1 ? (
                  <span
                    style={{ color: 'grey' }}
                    className="xrs-product__compatible-options"
                  >
                    {' '}
                    {optionsize} Compatible Options
                  </span>
                ) : null}
              </div>
            </div>
            <span className="xrs-product__name" data-testid="productname">
              {!isSimpleProduct ||
              singleProduct.variantName.includes('Default Title')
                ? ReactHtmlParser(singleProduct.productName)
                : ReactHtmlParser(singleProduct.variantName)}
            </span>
          </a>
          <div className="xrs-select-wrapper" data-testid="product_selection">
            {!isSimpleProduct ? this.selectComponent(singleProduct) : null}
          </div>
        </div>
        <div className="xrs-product__price-add-to-cart">
          <ProductPriceString
            price={singleProduct.price}
            compareAtPrice={singleProduct.compareAtPrice}
            currency={singleProduct.currency}
          />
          {singleProduct.extraData && (
            <ProductExtraData extraData={singleProduct.extraData} />
          )}

          {this.state.showAddtoCart ? (
            <div className="xrs-product-section">
              {/* <p>Score :- {this.props.score}</p> */}
              <ProductAddToCart
                _singleProduct={singleProduct}
                _variantId={singleProduct.merchantProductSku}
                _baseItemId={this.props.sourceMerchantProductSku}
                _userId={this.props.userId}
                _singleProductName={
                  !isSimpleProduct ||
                  singleProduct.variantName.includes('Default Title')
                    ? ReactHtmlParser(singleProduct.productName)
                    : ReactHtmlParser(singleProduct.variantName)
                }
                _singleProductImage={singleProduct.url_image}
                _singleProductPrice={
                  singleProduct.currency == 'USD'
                    ? `$` + singleProduct.price + '.00'
                    : singleProduct.currency + singleProduct.price + '.00'
                }
                isReel={this.props.isReel}
                _singleProductCat={this.props.categoryName}
                rootProductData={this.props.rootProductData}
                _finalProductID={this.props.rootProductData[1]}
                _parentProductID={this.props.rootProductData[0]}
                _parentProductName={this.props.rootProductData[2]}
                _source={'XRS'}
                _version={'V3'}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
export default Product;
